import { useState } from 'react';

export default function ProjectShowcase() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      image: 'https://public.readdy.ai/ai/img_res/8822432f68403ea49e44c783232b03fe.jpg',
      rating: 5,
      text: 'S2K made our renovation cleanup stress-free. The skip arrived on time and was collected promptly. Highly recommend!',
      name: 'Jane Davidson',
      role: 'Homeowner',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20woman%20smiling%20portrait%20headshot%20with%20clean%20simple%20background&width=100&height=100&seq=avatar-jane-004&orientation=squarish'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=commercial%20office%20building%20waste%20management%20with%20large%20skip%20bins%20for%20business%20waste%20disposal%20showing%20organized%20professional%20service%20in%20urban%20setting&width=600&height=400&seq=project-s2k-005&orientation=landscape',
      rating: 5,
      text: 'Excellent service for our office refurbishment. Professional team and competitive pricing. Will definitely use again.',
      name: 'Michael Roberts',
      role: 'Business Owner',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20businessman%20smiling%20portrait%20headshot%20with%20clean%20simple%20background&width=100&height=100&seq=avatar-michael-006&orientation=squarish'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=large%20construction%20site%20with%20heavy%20duty%20industrial%20skip%20bins%20managing%20building%20waste%20with%20cranes%20and%20equipment%20showing%20efficient%20waste%20disposal%20operations&width=600&height=400&seq=project-s2k-007&orientation=landscape',
      rating: 5,
      text: 'We use S2K for all our construction projects. Reliable, efficient, and always deliver on their promises.',
      name: 'David Thompson',
      role: 'Construction Manager',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20construction%20manager%20smiling%20portrait%20headshot%20with%20clean%20simple%20background&width=100&height=100&seq=avatar-david-008&orientation=squarish'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Trusted by Homeowners & Businesses Alike
          </h2>
          <p className="text-lg text-gray-400">
            See what our satisfied customers have to say
          </p>
        </div>

        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full flex-shrink-0 px-4">
                  <div className="max-w-4xl mx-auto">
                    <div className="bg-white rounded-3xl overflow-hidden shadow-2xl">
                      <div className="relative h-80">
                        <img
                          src={testimonial.image}
                          alt={`Project ${index + 1}`}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                      </div>
                      <div className="p-10">
                        <div className="flex items-center mb-4">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <i key={i} className="ri-star-fill text-orange-500 text-xl"></i>
                          ))}
                        </div>
                        <p className="text-xl text-gray-700 italic mb-6 leading-relaxed">
                          "{testimonial.text}"
                        </p>
                        <div className="flex items-center">
                          <img
                            src={testimonial.avatar}
                            alt={testimonial.name}
                            className="w-14 h-14 rounded-full object-cover mr-4"
                          />
                          <div>
                            <div className="font-bold text-gray-900">{testimonial.name}</div>
                            <div className="text-sm text-gray-600">{testimonial.role}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-line text-2xl text-gray-900"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-line text-2xl text-gray-900"></i>
          </button>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  currentSlide === index ? 'bg-orange-500 w-8' : 'bg-gray-600'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
